import { Listbox, Transition } from "@headlessui/react";
import { Fragment } from "react";
import { HiChevronUpDown } from "react-icons/hi2";

export default function ListSelect({
  className,
  options,
  selected,
  setSelected,
}) {
  return (
    <div className={className}>
      <Listbox value={selected} onChange={(e) => setSelected(e)}>
        <div className="relative mt-1">
          <Listbox.Button className="border h-10 relative w-full cursor-default rounded bg-white py-2 pl-3 pr-10 text-left focus:outline-none sm:text-sm">
            <span className="block truncate">{selected?.name}</span>
            <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
              <HiChevronUpDown
                className="h-5 w-5 text-gray-400"
                aria-hidden="true"
              />
            </span>
          </Listbox.Button>
          <Transition
            as={Fragment}
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Listbox.Options className="absolute mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
              {options?.map((item, i) => (
                <Listbox.Option
                  key={i}
                  className={({ active, selected }) =>
                    `
                  ${selected && "bg-gray-500 text-white"} 
                  cursor-default select-none relative py-2 pl-3 pr-4 gap-2 hover:bg-gray-500  
                  ${active ? "bg-gray-900 text-white" : ""}`
                  }
                  value={item}
                >
                  {({ selected }) => (
                    <>
                      <span
                        className={`block truncate ${
                          selected ? "font-medium" : "font-normal"
                        }`}
                      >
                        {item.name}
                      </span>
                      {selected ? (
                        <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-amber-600"></span>
                      ) : null}
                    </>
                  )}
                </Listbox.Option>
              ))}
            </Listbox.Options>
          </Transition>
        </div>
      </Listbox>
    </div>
  );
}
